export default __webpack_public_path__ + "static/media/guide24.876a781b.png";